/*
 * eMarketingeye
 */
function factory({ window, document, thn }) {

  const engine = {};
  let emarketingeyeCurrencyObserver;

  engine.priceObserveDom = function priceObserveDom(ctx) {

    const rateElement = document.querySelector('[id$=lowestRateTxt]');

    if (rateElement && !emarketingeyeCurrencyObserver) {
      emarketingeyeCurrencyObserver = thn.debounce(() => ctx.widget.update(), 500);

      thn.observeDom(rateElement, emarketingeyeCurrencyObserver, {
        childList: true,
        subtree: false,
        attributes: false,
      });

      thn.pageUnload(function () {
        emarketingeyeCurrencyObserver.cancel();
        thn.stopObserveDom(rateElement, emarketingeyeCurrencyObserver);
        emarketingeyeCurrencyObserver = null;
      });
    }
  };

  /**
    * @memberOf module:bs_142
    * @see {@link generate_search_url}
    *
    * @param {object} ctx - The context object.
    */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.match(/reservations/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }
    url.searchParams.set('ci', '[date_begin]');
    url.searchParams.set('co', '[date_end]');
    url.searchParams.set('convcurrency', '[currency]');
    ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$2-$1');
    ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$2-$1');
    ctx.newUrl = url.toString();

    return ctx;
  };

  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;
    const promoCode = thn.parseUrlParameter('promo');
    const isInvalidPromCode = ['JW2025', 'BNAWEDDING'].includes(promoCode);

    // format: 29-08-2017
    widgetData.dateBegin = (thn.parseUrlParameter('ci') || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    widgetData.dateEnd = (thn.parseUrlParameter('co') || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

    // Room
    widgetData.rooms = 1;

    // Check first if adults dropdown is visible after selecting the desired room
    const totalAdults = $('.adultselect');
    widgetData.adults = totalAdults.val() ? parseInt(totalAdults.val(), 10) : 1;
    widgetData.children = 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Prices
    /*
         * Check first if total price based on how many adults are selected is visible
         */
    let prices = [];
    // #totalrooms-value will contain total price per stay without taxes
    const $totalPrice = $('#totalrooms-value');
    if ($totalPrice.text() !== '' && !isInvalidPromCode) {
      widgetData.price = thn.parseNumber($totalPrice.text())
                / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      widgetData.currency = thn.getCurrencyCode($('.currency-type').eq(0).text());
      widgetData.set = true;
    } else {
      const $prices = $('[id$="_lowestRateTxt"] > strong').map(function (idx, el) {
        const parts = $(el).text().match(/from\s*:\s*(.*)/i);
        return parts && parts[1];
      }).filter(function (idx, el) {
        return el;
      });

      prices = $prices.map(function (idx, txt) {
        return thn.parseNumber(txt);
      }).toArray();

      if (prices.length && !isInvalidPromCode) {
        widgetData.price = Math.min(...prices);
        widgetData.currency = thn.getCurrencyCode($prices.get(0).trim().match(/[^\d\s,.]+/)[0]);
        widgetData.set = true;
      } else if ($('#error_message:visible').length) {
        widgetData.noRooms = true;
      }
    }

    return widgetData;
  };

  engine.bookingParseData = function bookingParseData(ctx) {

    var widgetData = {};
    var $ = window.jQuery;

    if ($ && $('.rp_error:visible').length) {

      // error
      widgetData.set = false;

    } else if ($) {

      widgetData.bookingId = $('td:contains("Reservation ID")').siblings().text().trim();

      const price = $('td:contains("Total Amount")').siblings().text().trim();
      if (price) {
        widgetData.price = thn.parseNumber(price);
        if (!widgetData.currency) {
          widgetData.currency = thn.getCurrencyCode(price.match(/[^\d\s,.]+/)[0]);
        }
      }

      const checkin = $('td:contains("Check in Date")').siblings().text();
      if (checkin) {
        widgetData.dateBegin = checkin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      }
      const checkout = $('td:contains("Check out Date")').siblings().text();
      if (checkout) {
        widgetData.dateEnd = checkout.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      }
    }

    return widgetData;
  };

  return engine;

}

export { factory };
